<template>
  <v-layout row wrap>
    <v-flex xs10>
      <v-card class="elevation-0">
        <v-alert type="info" :value="true" class="black--text">
          {{ messages.info.TRANSFORMJS_INFO }}
        </v-alert>
        <v-card-text class="ml-0 vop--ace-editor-container" :style="{ height: editorHeight }">
          <div ref="editorEditable" class="vop--ace-editor"></div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import ace from "brace"
import "brace/mode/javascript"
import "brace/theme/eclipse"
import "brace/ext/searchbox"
import messages from "@/XVAT/messages.json"
import XVATRulesService from "@/XVAT/XVATRulesService"

export default {
  name: "TransformByJSAction",
  data() {
    return {
      actionJS: ""
    }
  },
  computed: {
    editorHeight() {
      let height = 50
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          height = 55
          break
        case "sm":
          height = 55
          break
        case "md":
          height = 60
          break
        case "lg":
          height = 60
          break
        case "xl":
          height = 65
          break
      }
      // if (this.errorAlert) {
      //   height = height - 8
      // }
      return `${height}vh`
    }
  },
  methods: {
    /**
     * initialize JS Editor
     */
    initJSEditor() {
      let editor
      editor = ace.edit(this.$refs.editorEditable)
      editor.setTheme("ace/theme/eclipse")
      editor.getSession().setMode("ace/mode/javascript")
      editor.session.setValue(this.actionJS)
    },

    /**
     * Load transform by js action data
     */
    loadActionData(data) {
      let editor
      editor = ace.edit(this.$refs.editorEditable)
      if (data) {
        this.actionJS = data.actions[0]
        editor.session.setValue(this.actionJS)
      }
    },

    /**
     * validateAction -
     */
    validateJSAction() {
      let editor
      editor = ace.edit(this.$refs.editorEditable)
      let actionJSString = editor.getValue()
      // NOTE: For now passing 'true' but need to comeback and re-evaluate
      XVATRulesService.$emit(
        "event:ruleJSActionValidation",
        true,
        actionJSString
      )
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     *
     */
    XVATRulesService.$on("event:ruleDataRetrieved", this.loadActionData)
    XVATRulesService.$on("event:validteJSAction", this.validateJSAction)
  },
  mounted() {
    this.initJSEditor()
  },
  beforeDestroy() {
    XVATRulesService.$off("event:ruleDataRetrieved", this.loadActionData)
    XVATRulesService.$off("event:validteJSAction", this.validateJSAction)
  }
}
</script>
<style lang="scss">
.vop--ace-editor-container {
  position: relative;
}

.vop--ace-editor {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

.vop--ace-editor .ace_search_field,
.ace_searchbtn:last-child {
  color: black !important;
}

.vop--acediff-editor-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  width: 100%;
  top: 0px !important;
  left: 0px;
  height: 100%;
  overflow: auto;
}

.vop--acediff-editor-container>div {
  flex-grow: 1;
  -webkit-flex-grow: 1;
  position: relative;
}

.vop--acediff-editor-container>div.vop--acediff-gutter {
  flex: 0 0 60px;
  -webkit-flex: 0 0 60px;
  border-left: 1px solid #999999;
  border-right: 1px solid #999999;
  background-color: #efefef;
  overflow: hidden;
}

.vop--acediff-gutter svg {
  background-color: #efefef;
}

.vop--acediff-editor {
  position: absolute !important;
  top: 0;
  bottom: 0;
  width: 100%;
}

/** acediff specific styles, need to move in to a commmon style sheet */
.acediff-diff {
  background-color: #d8f2ff;
  border-top: 1px solid #a2d7f2;
  border-bottom: 1px solid #a2d7f2;
  position: absolute;
  z-index: 4;
}

.acediff-diff.targetOnly {
  height: 0px !important;
  border-top: 1px solid #a2d7f2;
  border-bottom: 0px;
  position: absolute;
}

.acediff-connector {
  fill: #d8f2ff;
  stroke: #a2d7f2;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/Rule/TransformByJSAction.vue